import { BLACK, BLACK_100, BLACK_500, BLACK_600, BLACK_700, BLACK_800, BLACK_900, BLUE_500, BLUE_GREY_200, BLUE_GREY_300, BLUE_GREY_400, LILAC_300, LILAC_400, LILAC_700, WHITE } from '../colors';
var iconButtonConfig = {
  theme: 'light',
  labelPosition: 'bottom',
  type: 'primary',
  size: 'sm',
  controlState: 'none',
  showFlourish: false,
  disabled: false,
  selected: false,
  noBgColor: false,
  noContainer: false,
  variant: 'icon',
  config: {
    primary: {
      size: {
        sm: {
          iconButtonSize: 40,
          iconSize: 20
        },
        md: {
          iconButtonSize: 48,
          iconSize: 24
        },
        lg: {
          iconButtonSize: 56,
          iconSize: 32
        }
      },
      controlState: {
        none: {
          buttonColor: BLACK_900,
          textColor: BLACK_900,
          iconColor: BLACK_100
        },
        disabled: {
          buttonColor: BLACK_500,
          textColor: BLACK_600,
          iconColor: BLACK_700
        },
        hover: {
          buttonColor: BLACK_800,
          textColor: BLACK_900,
          borderWidth: 1,
          borderColor: BLACK,
          iconColor: BLACK_100
        },
        pressed: {
          buttonColor: BLACK_900,
          textColor: BLACK_900,
          iconColor: BLACK_100
        },
        selected: {
          buttonColor: BLUE_500,
          textColor: BLACK_900,
          iconColor: WHITE
        }
      }
    },
    secondary: {
      size: {
        sm: {
          iconButtonSize: 40,
          iconSize: 20
        },
        md: {
          iconButtonSize: 48,
          iconSize: 24
        },
        lg: {
          iconButtonSize: 56,
          iconSize: 32
        }
      },
      controlState: {
        none: {
          buttonColor: LILAC_400,
          textColor: BLACK_900,
          iconColor: BLACK
        },
        disabled: {
          buttonColor: BLACK_500,
          textColor: BLACK_600,
          iconColor: BLACK_700
        },
        hover: {
          buttonColor: LILAC_300,
          textColor: BLACK_900,
          borderWidth: 1,
          borderColor: LILAC_700,
          iconColor: BLACK
        },
        pressed: {
          buttonColor: LILAC_300,
          textColor: BLACK_900,
          iconColor: BLACK
        },
        selected: {
          buttonColor: BLACK_900,
          textColor: BLACK_900,
          iconColor: WHITE
        }
      }
    }
  }
};
var whiteConfig = Object.assign(Object.assign({}, iconButtonConfig), {
  config: Object.assign(Object.assign({}, iconButtonConfig.config), {
    primary: Object.assign(Object.assign({}, iconButtonConfig.config.primary), {
      controlState: {
        none: {
          buttonColor: BLUE_GREY_200,
          textColor: BLACK_900,
          iconColor: BLACK
        },
        disabled: {
          buttonColor: BLUE_GREY_200,
          textColor: BLACK_600,
          iconColor: BLUE_GREY_400
        },
        hover: {
          buttonColor: BLUE_GREY_200,
          textColor: BLACK_900,
          borderWidth: 1,
          borderColor: BLUE_GREY_300,
          iconColor: BLACK_900
        },
        pressed: {
          buttonColor: BLUE_GREY_400,
          textColor: BLACK_900,
          iconColor: BLACK
        },
        selected: {
          buttonColor: BLACK_900,
          textColor: BLACK_900,
          iconColor: WHITE
        }
      }
    }),
    secondary: Object.assign(Object.assign({}, iconButtonConfig.config.secondary), {
      controlState: {
        none: {
          buttonColor: BLACK_900,
          textColor: BLACK_900,
          iconColor: BLACK_100
        },
        disabled: {
          buttonColor: BLACK_500,
          textColor: BLACK_600,
          iconColor: BLACK_700
        },
        hover: {
          buttonColor: BLACK_800,
          textColor: BLACK_900,
          borderWidth: 1,
          borderColor: BLACK,
          iconColor: BLACK_100
        },
        pressed: {
          buttonColor: BLACK,
          textColor: BLACK_900,
          iconColor: BLACK_100
        },
        selected: {
          buttonColor: BLUE_500,
          textColor: BLACK_900,
          iconColor: WHITE
        }
      }
    })
  })
});
export default {
  light: iconButtonConfig,
  dark: iconButtonConfig,
  white: whiteConfig
};